import React, { useCallback, useState } from 'react';
import { ActiveConstants } from 'finhelper';
import { ContainerIconWrapper as Container } from 'src/pages/Investing/Invests/components/styles';
import { Popup } from 'src/interface/cabinet/header/Dropdown/styles';
import NotificationIcon from '#app/assets/icons/notification.svg';

/** @param {{ active: import('finhelper').GridActiveModel }} props */
const CustomActivePopup = ({ active }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMouseOver = useCallback(() => setIsOpen(true), []);
  const handleMouseLeave = useCallback(() => setIsOpen(false), []);

  if (active.item_type !== ActiveConstants.CUSTOM_CATALOG) return null;

  return (
    <Container onMouseOver={handleMouseOver} onMouseLeave={handleMouseLeave}>
      <img src={NotificationIcon} alt="" />
      <Popup
        open={isOpen}
        id={'popup-custom-' + active.id}
        className="asset-popup"
        $position={{ top: '-10px', left: '24px' }}
        width={'300px'}
      >
        <div style={{ padding: '10px 20px', minWidth: 'fit-content' }}>
          Актив создан без привязки к справочнику,
          <br /> невозможно загрузить актуальную цену
        </div>
      </Popup>
    </Container>
  );
};

export default CustomActivePopup;
